import { DateTime } from 'luxon';
import * as Yup from 'yup';
import { yupBaseEmail, yupBaseString } from '../../utils/yup';

const requiredMessage = 'This field is required';
const fileMaxSizeInMb = 15;

export const PhysicalExamInfoSchema = Yup.object().shape({
  firstName: yupBaseString('First Name').min(2).max(25).required(requiredMessage),
  lastName: yupBaseString('Last Name').required(requiredMessage),
  email: yupBaseEmail('Email').required(requiredMessage),
  verifyEmail: yupBaseEmail('Verify your Email')
    .oneOf([Yup.ref('email'), undefined], 'Emails don\'t match')
    .required('Please confirm your email'),
  dateOfBirth: Yup.string()
    .required('Please choose a date')
    .test(
      'is-valid-date',
      'Please choose a valid date',
      (value: string | null | undefined) => {
        if (!value) return false;
        const dateOfBirth = DateTime.fromFormat(value, 'MM/dd/yyyy');
        return dateOfBirth.isValid;
      },
    )
    .test(
      'is-adult',
      'You must be 18 or older to use the service',
      (value: string | null | undefined) => {
        const dateOfBirth = DateTime.fromFormat(value || '', 'MM/dd/yyyy');
        if (!dateOfBirth.isValid) {
          return false;
        }
        const now = DateTime.local();
        const age = now.diff(dateOfBirth, 'years').years;
        return age >= 18;
      },
    ),
  files: Yup.array()
    .min(1, 'You must upload at least one file.')
    .test('fileSize', `File size must be less than ${fileMaxSizeInMb}MB`, files => {
      const bigger = files?.some(s => (s.size / 1048576) > fileMaxSizeInMb);
      return !bigger;
    })
    .required('You must upload at least one file.'),
});
